/** @format */
import type { AxiosResponse, AxiosRequestConfig } from 'axios'
export interface ProductItem {
  productType: number
  productName: string
  costOptFlag: number
  iamProjectFlag: number
  namespace: string
  discoveryMetricFlag?: 0 | 1 // 是否是动态监控项
  childTypes?: ProductItem[]
  sysEventFlag: 0 | 1 // 是否支持事件告警
  thresholdFlag: 0 | 1 // 是否支持阈值告警
}

// 告警联系人
export interface AlarmReciverObject {
  contactname?: string
  contactid?: number
  contactflag?: number
  contactway?: number
}

// 替代响应request
export interface IRresponseConfig extends AxiosResponse {
  code?: string
  message?: string
  error?: any
}

export interface IAxiosRequestConfig extends AxiosRequestConfig {
  noloading?: boolean
}

// 前端导出数据表头格式
export interface ExportHeaders {
  key: string
  value: string
}

// 监控项
export interface MetricItem {
  metricName?: string
  metricKey?: string
  tags?: string
  units?: string
  delay?: number
  application?: string
  isDimension?: 0 | 1 // 是否有维度
}

// label/value
export interface LabelValueItem<L = string, V = string> {
  label: L
  value: V
}

// 资源
export interface InstanceItem {
  instanceIP: string
  instanceId: string
  instanceName: string
  properties: any
  region: string
  childType?: number
}

// Page
export interface PageProps {
  Page: number
  PageSize: number
}
export const initPage: PageProps = {
  Page: 1,
  PageSize: 20
}
